import 'magnific-popup';

const handleModal = ($modal = $('.js-modal')) => {
  $modal.magnificPopup({
    type: 'inline',
    preloader: false
  });

  $(document).on('click', '.popup-modal-dismiss', function (e) {
    $.magnificPopup.close();
    e.preventDefault();
  });
}

handleModal();

export default handleModal;
